/**
 * Created by david.vanoni@coplex.com on 1/27/18.
 */

import { initiativeUpload as initiativeUploadSchema } from '../lib/schema.js';
import { CALL_API, HTTP_METHODS } from '../middlewares/api.js';

// API Actions
const RETRIEVE_INITIATIVE_UPLOAD_REQUEST =
  'changesync/initiativeUploads/RETRIEVE_INITIATIVE_UPLOAD_REQUEST';
const RETRIEVE_INITIATIVE_UPLOAD_SUCCESS =
  'changesync/initiativeUploads/RETRIEVE_INITIATIVE_UPLOAD_SUCCESS';
const RETRIEVE_INITIATIVE_UPLOAD_FAILURE =
  'changesync/initiativeUploads/RETRIEVE_INITIATIVE_UPLOAD_FAILURE';

// Action Creators

export const retrieveInitiativeUpload = (id) => ({
  [CALL_API]: {
    types: [
      RETRIEVE_INITIATIVE_UPLOAD_REQUEST,
      RETRIEVE_INITIATIVE_UPLOAD_SUCCESS,
      RETRIEVE_INITIATIVE_UPLOAD_FAILURE,
    ],
    endpoint: `initiative_uploads/${id}`,
    method: HTTP_METHODS.GET,
    schema: initiativeUploadSchema,
  },
});
